// extracted by mini-css-extract-plugin
module.exports = {"container":"SharePost_container__ZOfRE","actionCopy":"SharePost_actionCopy__8XwMl","actionShare":"SharePost_actionShare__YJ_Kh","actioned":"SharePost_actioned__TO3Du"};